import { QUIZ_CATEGORIES } from "~/constants/questionnaire";

/**
 * Maps a quiz category to the analytics `widget` name reported in tracking
 * events. Shared by the legacy quiz (`components/Quiz`) and the extracted
 * `useWaitlist` hook. Categories not listed fall back to `"questionaire"` at
 * the call site.
 */
export const QUIZ_EVENTS: Record<string, { widget: string }> = {
    [QUIZ_CATEGORIES.OESTRA_CREAM_UPSELL_SHORT]: {
        widget: "oestra_quiz",
    },
    [QUIZ_CATEGORIES.FACE_CREAM_UPSELL_SHORT]: {
        widget: "anti_aging_fc_quiz",
    },
};
